import Es6Promise from 'es6-promise';
import fetchJsonp from 'fetch-jsonp';
import router from '@/router';
import { Base64 } from 'js-base64';
import md5 from 'js-md5';
import store from '@/store';
import axios from 'axios';
import { Stat, EStatReportDivision } from '@fontend9377/stat';
import CryptoJS from 'crypto-js';
// import { config } from 'process';

import companyEnum from "./company_enum";

Es6Promise.polyfill();
let delayLock = null; //跳转连接的防抖
let hasRedirected = false;
let userInfo = {}

// 有些接口401缺不需要跳登录，尽量不要影响
const toLoginApiArr = ['/game/evaluate','/game/evaluationReply','/thread/replyUser','/thread/commentReply','/thread/comment'];

class Util {
    // Vue = '';

    // VM = '';

    // debounce = '';

    // debounceFun = () => { };

    constructor() {
        // 初始化
        this.debounce = true;
        this.store = store;
        // // 初始化StatUtil实例
        // this.statUtil = new StatUtil(window.stat);
    }

    getUrlParam(name) {
        const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`); // 构造一个含有目标参数的正则表达式对象
        const r = window.location.search.substr(1).match(reg); // 匹配目标参数
        if (r != null) {
            return unescape(r[2]);
        }
        return null; // 返回参数值
    }

    getUrlParamObj(url) {
        const obj = {};
        if (url.indexOf("?") >= 0) {
            const arr1 = url.split("?");
            const arr2 = arr1[1].split("&");
            for (let i = 0; i < arr2.length; i++) {
                const res = arr2[i].split("=");
                obj[res[0]] = res[1];
            }
        }
        return obj;
    }

    filterLanguage() {
        // 获取url值
        const reg = new RegExp("language=([^&]*)(&|$)"); // 构造一个含有目标参数的正则表达式对象
        const r = window.location.search.substr(1).match(reg); // 匹配目标参数
        if (r) {
            return window.location.search.replace(r[0], "").replace("?", "&");
        }
        if (window.location.search) {
            return window.location.search.replace("?", "&");
        }
        return null;
    }

    toSchemeFn(scheme, url) {
        // 跳转到app
        const _scheme = scheme;
        const _url = url;
        const u = navigator.userAgent;

        if (/MicroMessenger/gi.test(u)) {
            // 是微信 在浏览器打开
            // 引导用户在浏览器中打开
            alert("请在浏览器中打开");
            return;
        }

        const d = new Date();
        const t0 = d.getTime();
        if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
            if (this.openApp(_scheme)) {
                // Android
                this.openApp(_scheme);
            } else {
                // 由于打开需要1～2秒，利用这个时间差来处理－－打开app后，返回h5页面会出现页面变成app下载页面，影响用户体验
                const delay = setInterval(() => {
                    const d = new Date();
                    const t1 = d.getTime();
                    if (t1 - t0 < 3000 && t1 - t0 > 2000) {
                        // alert('请下载APP');
                        window.location.href = _url;
                    }
                    if (t1 - t0 >= 3000) {
                        clearInterval(delay);
                    }
                }, 1000);
            }
        } else if (u.indexOf("iPhone") > -1) {
            if (this.openApp(_scheme)) {
                // IOS
                this.openApp(_scheme);
            } else {
                const delay = setInterval(() => {
                    const d = new Date();
                    const t1 = d.getTime();
                    if (t1 - t0 < 3000 && t1 - t0 > 2000) {
                        // alert('请下载APP');
                        window.location.href = _url;
                    }
                    if (t1 - t0 >= 3000) {
                        clearInterval(delay);
                    }
                }, 1000);
            }
        }
    }

    openApp(scheme) {
        if (this.checkUA() == "pc") {
            return false;
        }
        window.location.href = `${scheme}://`;
    }

    removeHTMLTag(str) {
        str = str.replace(/<\/?[^>]*>/g, ""); // 去除HTML tag
        str = str.replace(/[ | ]*\n/g, "\n"); // 去除行尾空白
        // str = str.replace(/\n[\s| | ]*\r/g,'\n'); //去除多余空行
        str = str.replace(/&nbsp;/gi, ""); // 去掉&nbsp;
        return str;
    }

    checkUA() {
        const browser = {
            versions: (function () {
                const u = navigator.userAgent;
                return {
                    // 移动终端浏览器版本信息
                    trident: u.indexOf("Trident") > -1, // IE内核
                    presto: u.indexOf("Presto") > -1, // opera内核
                    webKit: u.indexOf("AppleWebKit") > -1, // 苹果、谷歌内核
                    gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, // 火狐内核
                    mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
                    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
                    android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, // android终端或uc浏览器
                    iPhone: u.indexOf("iPhone") > -1, // 是否为iPhone或者QQHD浏览器
                    iPad: u.indexOf("iPad") > -1, // 是否iPad
                    webApp: u.indexOf("Safari") == -1, // 是否web应该程序，没有头部与底部
                };
            })(),
        };
        if (browser.versions.mobile) {
            // 判断是否是移动设备打开。browser代码在下面
            const ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                return "weixin";
            }
            if (ua.match(/WeiBo/i) == "weibo") {
                return "weibo";
            }
            if (ua.match(/QQ/i) == "qq") {
                return "qq";
            }
            if (browser.versions.ios) {
                return "ios";
            }
            if (browser.versions.android) {
                return "android";
            }
        } else {
            return "pc";
        }
    }

    encodeSearchParams(obj) {
        const params = [];

        Object.keys(obj).forEach((key) => {
            let value = obj[key];
            // 如果值为undefined我们将其置空
            if (typeof value === "undefined") {
                value = "";
            }
            // 对于需要编码的文本（比如说中文）我们要进行编码
            params.push([key, encodeURIComponent(value)].join("="));
        });

        return params.join("&");
    }

    async setFile(file) {
        let str = "";

        // FileReader可直接将上传文件转化为二进制流
        const reader = new FileReader();
        reader.readAsDataURL(file); // 转化二进制流，异步方法
        reader.onload = function () {
            // 完成后this.result为二进制流
            // console.log(this.result);
            // 页面显示文件名
            const base64Str = this.result;
            let startNum = base64Str && base64Str.indexOf("base64,");
            startNum = startNum * 1 + 7;
            // 去除前部格式信息（如果有需求）
            const baseStr = base64Str.slice(startNum);
        };

        const { length } = file.files;
        for (let i = 0; i < length; i++) {
            const temp = file.files[i].name;
            str += temp;
        }
        return str;
    }

    async uploadFile(url, type, file) {
        if (file == "") {
            window.Components.toast("请选择文件");
            return false;
        }
        const formData = new FormData();
        formData.append("name", file.files[0].name);
        formData.append("FILE_DATA", file.files[0]);
        formData.append("platform", this.Vue.config.platform);

        return await fetch(this.Vue.config.baseUrl + url, {
            method: type,
            headers: {
                // 'Content-Type': 'multipart/form-data',
                Token: this.Vue.config.token,
            },
            body: formData,
        })
            .then((res) => res.text())
            .then((res) => {
                if (res) {
                    const _returnData = JSON.parse(res);
                    if (_returnData.code == 1) {
                        return _returnData;
                    }
                    window.Components.toast(_returnData.msg);
                } else {
                    window.Components.toast("系统错误");
                }
            });
    }

    makeExpandingArea(el) {
        // 自动改变textarea 大小
        let timer = null;
        const defaultHeight = el.scrollHeight;

        // 由于ie8有溢出堆栈问题，故调整了这里
        const setStyle = function (el, auto) {
            if (auto) el.style.height = "auto";
            if (el.value.length == 0) {
                el.style.height = `${defaultHeight}px`;
            } else {
                el.style.height = `${el.scrollHeight}px`;
            }
        };

        const delayedResize = function (el) {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            timer = setTimeout(() => {
                setStyle(el);
            }, 200);
        };
        if (el.addEventListener) {
            el.addEventListener(
                "input",
                () => {
                    setStyle(el, 1);
                },
                false
            );
            setStyle(el);
        } else if (el.attachEvent) {
            el.attachEvent("onpropertychange", () => {
                setStyle(el);
            });
            setStyle(el);
        }
        if (window.VBArray && window.addEventListener) {
            // IE9
            el.attachEvent("onkeydown", () => {
                const key = window.event.keyCode;
                if (key == 8 || key == 46) delayedResize(el);
            });
            el.attachEvent("oncut", () => {
                delayedResize(el);
            }); // 处理粘贴
        }
    }

    async getJson(url, type, data, isToken, noNeedHost = false, isTime = true) {
        // 获取json数据 noNeedToken不需要token 传入true   isToken不需要host 传入true   isTime是否携带时间
        let _body = {};
        let _contentType = "";
        let _url = "";
        const apiUrl = url;

        if (type.toLocaleUpperCase() == "GET") {
            _body = null;
            url = `${url}?${this.encodeSearchParams(data)}`;
            // _contentType = 'application/x-www-form-urlencoded'; //新token传值方式
            _contentType = "application/json";
        } else if (type.toLocaleUpperCase() == "PUT") {
            _body = null;
            _contentType = "application/json";
            url = `${url}?${JSON.stringify(data)}`;
        } else {
            _body = this.encodeSearchParams(data);
            _contentType = "application/x-www-form-urlencoded";
        }

        if (noNeedHost) {
            _url = url;
        } else {
            _url = window.Config.host + '/api' + url;
        }
        if (isTime) {
            _url = _url + `${_url.indexOf("?") > -1 ? "&" : "?"}timeout${new Date().getTime()} = 1`;
        }


        const token = this.Cookie().get("access_token");

        const headers = {
            // 'Origin': this.Vue.config.baseUrl, //新token传值方式
            "Content-Type": _contentType,
        }

        if (isToken && token) {
            headers.Authorization = `Bearer ${token}`;

            headers['Company-Id'] = window.Config.companyId;
        }else if(isToken && !token){
            // 有些页面不需要token也穿了isToken过来...
            // let toPath = router.currentRoute.value.fullPath;
            // window.Components.toast('请先登录');
            // this.login({ query: { routerurl: toPath } })
            // return;
        }

        return await fetch(_url, {
            method: type,
            headers,
            body: _body,
        })
            .then((res) => {
                if(toLoginApiArr.includes(apiUrl)){
                    if(res&&res.status === 401){
                        window.Components.toast('登录已过期，请重新登录');
                        let toPath = router.currentRoute.value.fullPath;
                        console.log('toPath====>', toPath);
                        this.Cookie().remove("access_token");
                        this.login({ query: { routerurl: toPath } })
                        return;
                    }
                }
                return res.text()
            })
            .then((res) => {
                if (res) {
                    const _returnData = JSON.parse(res);
                    // console.log('这里是返回数据====>', _returnData)
                    if (_returnData.code == 0) {
                        return _returnData;
                    }

                    if (_returnData.code == 1 && url == '/cloudPhone/exchange' || '/stats/cloudPhone' || '/cloudPhone/auth' || '/cloudPhone/gamePackage') {
                        return _returnData;
                    }

                    if (_returnData.code === 1 && !hasRedirected) {
                        hasRedirected = true;
                        window.Components.toast(_returnData.message);
                        _returnData.msg = _returnData.message;
                        // window.location.href = '/login';
                        let toPath = router.currentRoute.value.fullPath;
                        this.Cookie().remove("access_token");
                        this.login({ query: { routerurl: toPath } })
                    }

                    return _returnData;
                }
                // console.log(JSON.stringify(_body));
                window.Components.toast(`系统错误${url + JSON.stringify(_body)} `);
            });
    }

    async getJson2(url, type, data, isToken, noNeedHost = false, isTime = true) {
        // 获取json数据 noNeedToken不需要token 传入true   isToken不需要host 传入true   isTime是否携带时间
        let _body = {};
        let _contentType = "";
        let _url = "";

        if (type.toLocaleUpperCase() == "GET") {
            _body = null;
            url = data ? `${url}?${this.encodeSearchParams(data)}` : `${url}`;
            _contentType = "application/json";
        } else if (type.toLocaleUpperCase() == "PUT") {
            _body = null;
            _contentType = "application/json";
            url = `${url}?${JSON.stringify(data)}`;
        } else {
            _body = JSON.stringify(data);
            _contentType = "application/json";
        }

        if (noNeedHost) {
            _url = url;
        } else {
            _url = window.Config.host + '/api' + url;
        }
        if (isTime) {
            _url = _url + `${_url.indexOf("?") > -1 ? "&" : "?"}timeout${new Date().getTime()} = 1`;
        }

        const token = this.Cookie().get("access_token");

        const headers = {
            // 'Origin': this.Vue.config.baseUrl, //新token传值方式
            "Content-Type": _contentType,
        }

        if (isToken && token) {
            headers.Authorization = `Bearer ${token}`;
            headers['Company-Id'] = window.Config.companyId;
        }

        return await fetch(_url, {
            method: type,
            headers,
            body: _body,
        })
            .then((res) => res.text())
            .then((res) => {
                if (res) {
                    const _returnData = JSON.parse(res);
                    if (_returnData.code == 0) {
                        return _returnData;
                    }

                    if (_returnData.code === 1 && !hasRedirected) {
                        hasRedirected = true;
                        window.Components.toast(_returnData.message);
                        _returnData.msg = _returnData.message;
                        // window.location.href = '/login';
                        let toPath = router.currentRoute.value.fullPath;
                        this.Cookie().remove("access_token");
                        this.login({ query: { routerurl: toPath } })
                    }

                    return _returnData;
                }
                // console.log(JSON.stringify(_body));
                window.Components.toast(`系统错误${url + JSON.stringify(_body)} `);
            });
    }

    async getUserJson(url, type, data, isToken, noNeedHost = false, isTime = true, isAutoLogin = true) {
        // 获取json数据 noNeedToken不需要token 传入true   isToken不需要host 传入true   isTime是否携带时间
        let _body = {};
        let _contentType = "";
        let _url = "";

        if (isToken) {
            data.access_token = this.Cookie().get("access_token");
        }

        const isMengwPlatform = window.Config.platform === 'mengw';
        const isChuangyuePlatform = window.Config.platform === 'chuangyue';

        if (type.toLocaleUpperCase() == "GET") {
            _body = null;
            url = `${url}?${this.encodeSearchParams(data)}`;
            _contentType = "application/json";
        } else if (type.toLocaleUpperCase() == "PUT") {
            _body = null;
            _contentType = "application/json";
            url = `${url}?${JSON.stringify(data)}`;
        } else {
            if (isMengwPlatform || isChuangyuePlatform) {
                // mengw平台使用form-urlencoded
                const formData = new URLSearchParams();
                for (const key in data) {
                    formData.append(key, data[key]);
                }
                _body = formData.toString();
                _contentType = "application/x-www-form-urlencoded";
            } else {
                // 默认使用json
                _body = JSON.stringify(data);
                _contentType = "application/json";
            }
        }

        if (noNeedHost) {
            _url = url;
        } else {
            _url = window.Config.userHost + url;
        }
        if (isTime) {
            _url = _url + `${_url.indexOf("?") > -1 ? "&" : "?"}timeout${new Date().getTime()} = 1`;
        }

        return await fetch(_url, {
            method: type,
            headers: {
                "Content-Type": _contentType
            },
            // credentials: 'include',
            body: _body,
        })
            .then((res) => res.text())
            .then((res) => {
                if (res) {
                    const _returnData = JSON.parse(res);
                    if (_returnData.code == 1) {
                        return _returnData;
                    }

                    if (_returnData.code === 45555 && !hasRedirected && isAutoLogin) {
                        hasRedirected = true;
                        this.customToast(_returnData.msg);
                        // window.location.href = '/login';
                        let toPath = router.currentRoute.value.fullPath;
                        this.Cookie().remove("access_token");
                        if(window.Config.platform == 'chuangyue') {
                            return _returnData;
                        }
                        this.login({ query: { routerurl: toPath } })
                    }

                    return _returnData;
                }
                // console.log(JSON.stringify(_body));
                window.Components.toast(`系统错误${url + JSON.stringify(_body)} `);
            });
    }

    // 平台手游币相关
    async getCurrencyJson(url, type, data, isToken, noNeedHost = false, isTime = true) {
        // 获取json数据 noNeedToken不需要token 传入true   isToken不需要host 传入true   isTime是否携带时间
        let _body = {};
        let _contentType = "";
        let _url = "";

        const token = this.Cookie().get("access_token");
        if (isToken && token) {
            data = { ...data, access_token: token};
        }

        if (window.Config.companyId) {
            data = { ...data, company_id: window.Config.companyId}
        }

        if (type.toLocaleUpperCase() == "GET") {
            _body = null;
            url = data ? `${url}?${this.encodeSearchParams(data)}` : `${url}`;
            _contentType = "application/json";
        } else if (type.toLocaleUpperCase() == "PUT") {
            _body = null;
            _contentType = "application/json";
            url = `${url}?${JSON.stringify(data)}`;
        } else {
            _body = JSON.stringify(data);
            _contentType = "application/json";
        }

        if (noNeedHost) {
            _url = url;
        } else {
            _url = window.Config.currencyHost + url;
        }
        if (isTime) {
            _url = _url + `${_url.indexOf("?") > -1 ? "&" : "?"}timeout${new Date().getTime()} = 1`;
        }


        const headers = {
            // 'Origin': this.Vue.config.baseUrl, //新token传值方式
            "Content-Type": _contentType,
        }

        if (isToken && token) {
            headers.Authorization = `Bearer ${token}`;
            // headers['Company-Id'] = window.Config.companyId;
        }

        return await fetch(_url, {
            method: type,
            headers,
            body: _body,
        })
            .then((res) => res.text())
            .then((res) => {
                if (res) {
                    const _returnData = JSON.parse(res);
                    if (_returnData.code == 1) {
                        return _returnData;
                    }

                    if (_returnData.code === 0 && !hasRedirected) {
                        hasRedirected = true;
                        if(_returnData.message !== '') {
                            window.Components.toast(_returnData.message);
                        }
                        _returnData.msg = _returnData.message;
                        // window.location.href = '/login';
                        let toPath = router.currentRoute.value.fullPath;
                        // this.Cookie().remove("access_token");
                        // this.login({ query: { routerurl: toPath } })
                    }

                    return _returnData;
                }
                // console.log(JSON.stringify(_body));
                window.Components.toast(`系统错误${url + JSON.stringify(_body)} `);
            });
    }

    async getJsonp(url, data, noNeedToken, noNeedHost = false) {
        // 获取json数据 noNeedToken不需要token 传入true   noNeedHost不需要host 传入true
        let _body = {};
        let _contentType = "";
        let _url = "";

        _body = null;
        url = `${url} `;
        _contentType = "application/json";

        if (noNeedHost) {
            _url = url;
        } else {
            _url = this.Vue.config.baseUrl + url;
        }

        return await fetchJsonp(_url, {})
            .then((res) => { })
            .then((res) => { })
            .catch((err) => {
                // console.log(`统计接口发送${ err } `);
            });
    }

    CSRegular() {
        return {
            reguname(v) {
                const rule1 = /^[a-zA-Z0-9\_]{6,20}$/.test(v); // 新注册帐号长度必须6-20
                return rule1;
            },
            uname(v) {
                const rule1 = /^[a-zA-Z0-9\_]{4,20}$/.test(v); // 老用户为4-20位
                return rule1;
            },
            pass(v) {
                return /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{6,32}$/.test(v);
            },
            phone(v) {
                return /^\d{11}$/.test(v);
            },
            captcha(v) {
                return /^\d{6}$/.test(v);
            },
            idcard(v) {
                return /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(
                    v
                );
            },
            readName(v) {
                return /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/.test(v);
            },
            QQNumber(v) {
                return /[1-9][0-9]{4,9}/.test(v);
            },
            email(v) {
                return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(v);
            },
            isNumber(v) {
                return Object.prototype.toString.call(v) == "[object Number]";
            },
            isString(v) {
                return Object.prototype.toString.call(v) == "[object String]";
            },
            isBool(v) {
                return Object.prototype.toString.call(v) == "[object Boolean]";
            },
            isNull(v) {
                return Object.prototype.toString.call(v) == "[object Null]";
            },
            isArray(v) {
                return Object.prototype.toString.call(v) == "[object Array]";
            },
            isObject(v) {
                return Object.prototype.toString.call(v) == "[object Object]";
            },
            isDate(v) {
                return Object.prototype.toString.call(v) == "[object Date]";
            },
            isFun(v) {
                return Object.prototype.toString.call(v) == "[object Function]";
            },
        };
    }

    share() {
        return {
            weibo(url, title, img) {
                const _url = url || window.location.href;
                const _title = title || document.title;

                if (img) {
                    window.location.href = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(
                        _url
                    )}&title=${_title}&pic=${img}`; // 自定义图片用这个
                } else {
                    window.location.href = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(
                        _url
                    )}&title=${_title}&searchPic=true`; // 微博自动抓取图片用这个
                }
            },
            qq(url, title, desc, img) {
                const share = {
                    title: title || document.title,
                    desc: desc || "",
                    image_url: img ? [img] : [],
                    share_url: url || window.location.href,
                };

                const image_urls = share.image_url.map((image) => encodeURIComponent(image));

                location.href = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(
                    share.share_url
                )}&site=掌上理工大&title=${share.title}&pics=${image_urls.join("|")}&summary=${share.desc
                    }`;
            },
        };
    }

    setPhotoPreview(str) {
        const reg = new RegExp("<img ", "g");
        const res = str.replace(reg, `<img preview="${new Date().getTime()}" `);
        return res;
    }

    getLocalStorage(key) {
        // 为了兼容安卓 全面改成cookie
        const str = this.Cookie().get(key);
        if (str == "undefined" || str == "" || str == "null") {
            return null;
        }
        return JSON.parse(str);
    }

    setLocalStorage(key, name, value, list) {
        if (name && value) {
            const _list = this.delLocalStorage(key, list, name, false);
            _list.push({ [name]: value });
            this.setCookie(key, _list);
        } else if (name) {
            const _list = this.delLocalStorage(key, list, name, false);
            _list.push(name);
            this.setCookie(key, _list);
        } else {
            this.setCookie(key, list);
        }
    }

    setCookie(key, list) {
        if(window.Config.platform == 'm9377') {
            this.Cookie().set(key, list, { domain: '.9377.cn' });
        }else if(window.Config.platform == 'mengw'){
            this.Cookie().set(key, list, { domain: '.mengw.com' });
        }else{
            this.Cookie().set(key, list, { domain: '.chuangyuejoy.com' });
        }
    }

    //原生LocalStorage
    setOriginalLocalStorage(name, value) {
        localStorage.setItem(name, JSON.stringify(value));
    }

    getOriginalLocalStorage(name) {
        new Util().setCookieLocalStorage(name, JSON.parse(localStorage.getItem(name)))
        return JSON.parse(localStorage.getItem(name));
    }

    delOriginalLocalStorage(name) {
        localStorage.removeItem(name);
    }

    clearOriginalLocalStorage() {
        localStorage.clear();
    }
    //原生LocalStorage

    //兼容cookies和localStorage
    setCookieLocalStorage(key, list) {
        if(window.Config.platform == 'm9377') {
            this.Cookie().set(key, list, { domain: '.9377.cn' });
        }else if(window.Config.platform == 'mengw'){
            this.Cookie().set(key, list, { domain: '.mengw.com' });
        }else {
            this.Cookie().set(key, list, { domain: '.chuangyuejoy.com' });
        }
        this.setOriginalLocalStorage(key, list)
    }

    getCookieLocalStorage(key) {
        if (this.getOriginalLocalStorage(key)) {
            return this.getOriginalLocalStorage(key)
        } else if (JSON.parse(this.Cookie().get(key))) {
            return JSON.parse(this.Cookie().get(key))
        } else {
            return null
        }
    }

    delCookieLocalStorage(key) {
        this.Cookie().remove(key);
        this.delOriginalLocalStorage(key)
    }
    //兼容cookies和localStorage

    delLocalStorage(key, list, name, isSet) {
        const _list = list;
        if (_list) {
            for (let i = 0; i < _list.length; i++) {
                if (this.CSRegular().isString(_list[i])) {
                    if (_list[i] == name) _list.splice(i, 1);
                } else if (_list[i].name == name) _list.splice(i, 1);
            }
        }

        if (isSet) {
            localStorage.setItem(key, _list);
        }
        return list;
    }

    getTimestamp() {
        return new Date().getTime() / 1000 + 3600;
    }

    formatHideMobile(mobile) {
        const _mobile = mobile;
        return `${_mobile.substr(0, 3)}****${_mobile.substr(7)}`;
    }

    throttle(fn, delay) {
        let timer = null;
        const remaining = 0;
        let previous = new Date();
        return () => {
            const now = new Date();
            const remaining = now - previous;
            const args = arguments;
            const context = this;

            if (remaining >= delay) {
                if (timer) {
                    clearTimeout(timer);
                }

                fn.apply(context, args);
                previous = now;
            } else if (!timer) {
                timer = setTimeout(() => {
                    fn.apply(context, args);
                    previous = new Date();
                }, delay - remaining);
            }
        };
    }

    debounceFunc(func, wait, immediate) {
        let timeout;
        return function () {
            let context = this;
            let args = arguments;
            if (timeout) clearTimeout(timeout);
            if (immediate) {
                let callNow = !timeout;
                timeout = setTimeout(function () {
                    timeout = null;
                }, wait)
                if (callNow) {
                    func.apply(context, args)
                }
            }
            else {
                timeout = setTimeout(function () {
                    func.apply(context, args)
                }, wait);
            }
        }
    }

    toPicUrl(url) {
        if (url == "") {
            return false;
        }

        const first = url.replace(/([#][^]+)$/, "");
        const last = url.match(/([^#]+)$/)[1];

        if (first === "gameid") {
            this.toDeatil(last);
        } else if (first === "bbs") {
            this.toForumGameUrl(last);
        } else if (first === "tid") {
            this.toPagasDetailUrl(last);
        } else if (first === "bindPhone") {
            this.toNativeBindPhone();
        } else if (first === "resetUser") {
            this.nativeOpenEditIntro();
        } else if (first === "native") {
            this.toNativeUrl(this.getFristIndexOfLastUrl(url, "#"));
        } else if (first === "inset") {
            this.toBoxUrl(last);
        } else {
            try {
                try {
                    try {
                        window.Gamebox.openGamePage(last); // h5
                    } catch (error) {
                        window.Native.openGamePage(last); // h5
                    }
                } catch (error) {
                    try {
                        window.Gamebox.openNewPage(last); // h5
                    } catch (error) {
                        window.Native.openNewPage(last); // h5
                    }
                }
            } catch (error) {
                //   console.log('客户端打开');
                window.location.href = last;
            }
        }
    }

    // 获取首先匹配字符
    getFristIndexOfLastUrl(url, key) {
        const length = url.indexOf(key);
        const last = url.slice(length + 1);
        return last;
    }

    getCookiesObj() {
        // 获取cookie对象，以对象表示
        const cookies = {};
        if (document.cookie) {
            const objs = document.cookie.split("; ");
            for (const i in objs) {
                const index = objs[i].indexOf("=");
                const name = objs[i].substr(0, index);
                const value = objs[i].substr(index + 1, objs[i].length);
                cookies[name] = value;
            }
        }
        return cookies;
    }

    timestampToTime(timestamp) {
        // 时间戳转换
        const date = new Date(timestamp * 1000); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        const Y = `${date.getFullYear()}-`;
        const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
        const D = `${date.getDate()} `;
        const h = `${date.getHours()}:`;
        const m = date.getMinutes();
        // let s = date.getSeconds();
        return Y + M + D + h + m;
    }

    timestampToDay(timestamp) {
        // 时间戳转换
        const date = new Date(timestamp * 1000); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        const Y = `${date.getFullYear()}-`;
        const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
        const D = `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}`;
        const h = `${date.getHours()}:`;
        const m = date.getMinutes();
        // let s = date.getSeconds();
        return Y + M + D;
    }

    timestampToTimeChinese(timestamp) {
        // 时间戳转换
        const date = new Date(timestamp * 1000); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        const Y = `${date.getFullYear()}`;
        const M = `${date.getMonth() + 1 < 10 ? `${date.getMonth() + 1}` : date.getMonth() + 1}`;
        const D = `${date.getDate()}`;
        const h = `${date.getHours()}`;
        let m = date.getMinutes();
        if (m <= 9) m = `0${m}`;
        // let s = date.getSeconds();
        return `${M}月${D}日 ${h}:${m}`;
    }

    timestampToTime2(times) {
        // 时间戳转换
        const date = new Date(times);
        const Y = `${date.getFullYear()}`;
        const M = `${date.getMonth() + 1 < 10 ? `${date.getMonth() + 1}` : date.getMonth() + 1}`;
        const D = `${date.getDate()}`;
        const h = `${date.getHours()}`;
        let m = date.getMinutes();
        if (m <= 9) m = `0${m}`;
        // let s = date.getSeconds();
        return `${Y}.${M}.${D} ${h}:${m}`;
    }

    getTimeFormat(timeS) {
        //时间转换时间戳(豪秒级)
        let time = (new Date(timeS.replace(/-/g, '/')).getTime()); //除1000 是变成秒级的时间戳 不除就是毫秒级
        return time;
    }

    getTimeFormatS(timeS) {
        //时间转换时间戳(秒级)
        let time = (new Date(timeS.replace(/-/g, '/')).getTime()) / 1000; //除1000 是变成秒级的时间戳 不除就是毫秒级
        return time;
    }

    getTimeMiddle(sTime, oTime) {
        //判断时间是否在开始时间和结束时间内
        let startTime = this.getTimeFormat(sTime);
        let overTime = this.getTimeFormat(oTime);
        let nowTime = Date.now();
        if (startTime <= nowTime && nowTime <= overTime) {
            return true;
        } else {
            return false;
        }
    }

    getYMD() {
        //获取今天的年月日
        const date = new Date();
        const Y = `${date.getFullYear()}`;
        const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}`;
        const D = `${date.getDate()}`;
        return `${Y}${M}${D}`;
    }

    Cookie() {
        return {
            // 设置cookie
            set: (name, value, opts) => {
                // opts maxAge, path, domain, secure
                if (name && value) {
                    let cookie = `${encodeURIComponent(name)}=${value}`;
                    // 可选参数
                    if (opts) {
                        if (opts.maxAge) {
                            cookie += `; max-age=${opts.maxAge}`;
                        }
                        if (opts.path) {
                            cookie += `; path=${opts.path}`;
                        }
                        if (opts.domain) {
                            cookie += `; domain=${opts.domain}`;
                        }
                        if (opts.secure) {
                            cookie += "; secure";
                        }
                        if (opts.expires) {
                            cookie += `; expires=${opts.expires}`;
                        } else {
                            const d = new Date();
                            d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000); // 一个月
                            const expires = `expires=${d.toUTCString()}`;
                            cookie += `; expires=${expires}`;
                        }
                    }
                    //兼容cookies和localStorage
                    document.cookie = cookie;
                    window.localStorage.setItem(name, JSON.stringify(value));
                    return cookie;
                }
                return "";
            },
            // 获取cookie
            get: (name) => {
                if (window.localStorage.getItem(name)) {
                    const localStr = window.localStorage.getItem(name);
                    if (localStr) {
                        return JSON.parse(localStr);
                    }
                    return null;
                } else {
                    const str = this.getCookiesObj()[name];
                    if (str) {
                        try {
                            return JSON.parse(decodeURIComponent(str));
                        } catch (e) {
                            // 如果解析JSON失败，直接返回原始字符串（用于处理JWT令牌等非JSON格式值）
                            return decodeURIComponent(str);
                        }
                    }
                    return null;
                }
            },
            // 清除某个cookie
            remove: (name) => {
                try {
                    if (window.localStorage.getItem(name)) {
                        window.localStorage.removeItem(name);
                    }
                } catch (e) {
                    console.log(e);
                }

                if (this.getCookiesObj()[name]) {
                    document.cookie = `${name}=; max-age=0`;
                }
            },

            // 清除所有cookie
            clear: () => {
                const cookies = this.getCookiesObj();
                for (const key in cookies) {
                    document.cookie = `${key}=; max-age=0`;
                }

                try {
                    window.localStorage.clear();
                } catch (e) {
                    console.log(e);
                }
            },
            // 获取所有cookies
            getCookies: (name) => this.getCookiesObj(),
            // 解决冲突
            noConflict: (name) => {
                if (name && typeof name === "string") {
                    if (name && window.cookie) {
                        window[name] = window.cookie;
                        delete window.cookie;
                        return window[name];
                    }
                } else {
                    return window.cookie;
                }
            },
        };
    }


    judgeJumpUrl() {
        console.log("judgeJumpUrl");
        try {
            const routerurl = this.getUrlParam("routerurl");
            let redirecturl = this.getUrlParam("redirecturl");
            let active = this.getUrlParam("active");

            // 处理redirecturl情况
            if (redirecturl) {
                try {
                    const access_token = this.Cookie().get("access_token");
                    redirecturl += redirecturl.indexOf('?') < 0 ? `?access_token=${access_token}` : `&access_token=${access_token}`;
                    window.top.location.replace(redirecturl);
                    return;
                } catch (error) {
                    console.error('重定向到外部URL失败:', error);
                }
            }

            // 路由检查和跳转
            if (routerurl) {
                console.log('routerurl', routerurl);
                console.log('active', active)

                // 安全地检查当前路由
                let currentRouteName = '';
                try {
                    currentRouteName = router.currentRoute.value.name;
                    console.log('router.currentRoute.value.name', currentRouteName);
                } catch (error) {
                    console.error('获取当前路由名称失败:', error);
                }

                // 避免重复跳转到相同路由
                if(currentRouteName !== routerurl) {
                    try {
                        // 根据环境跳转到不同路径
                        if (!store.state.sdkInfo.isSdkEnv) {
                            // 使用path: "/" 可能导致错误，改为name方式
                            if(routerurl === '/'){
                                router.replace({
                                    name: 'game',
                                    query: {
                                        active: active ? active : ''
                                    }
                                }).catch(err => {
                                    console.error('跳转失败0:', err);
                                    // name: 'game'
                                    // 失败时尝试直接跳转到路径
                                    router.replace('/').catch(e => console.error('备用跳转也失败:', e));
                                });
                            }else if(routerurl === 'switchuser'){
                                router.replace({
                                    name: 'mine',
                                }).catch(err => {
                                    console.error('跳转失败 switchuser:', err);
                                });
                            }else {
                                router.replace({
                                    // path: routerurl,
                                    name: 'game',
                                    query: {
                                        active: active ? active : ''
                                    }
                                }).catch(err => {
                                    console.error('跳转失败1:', err);
                                    router.replace({
                                        name: 'game',
                                    }).catch(err => {
                                        console.error('跳转失败2:', err);
                                        // name: 'game'
                                        // 失败时尝试直接跳转到路径
                                        router.replace('/').catch(e => console.error('备用跳转也失败:', e));
                                    });
                                });
                            }
                        } else {
                            router.replace({
                                name: routerurl,
                            }).catch(err => {
                                console.error(`跳转到${routerurl}失败:`, err);
                                // 尝试通过name跳转
                                // router.replace({
                                //     name: routerurl.replace(/^\//, '')
                                // }).catch(e => console.error('备用跳转也失败:', e));
                                router.replace({
                                    name: "game",
                                }).catch(e => console.error('备用跳转也失败:', e));
                            });
                        }
                    } catch (error) {
                        console.error('路由跳转发生错误:', error);
                    }
                } else {
                    try {
                        router.replace({
                            name: 'mine',
                        }).catch(err => console.error('跳转到我的页面失败:', err));
                    } catch (error) {
                        console.error('跳转到我的页面发生错误:', error);
                    }
                }
            } else {
                // 没有指定路由时的默认跳转
                // try {
                //     if (!store.state.sdkInfo.isSdkEnv) {
                //         router.replace({
                //             name: 'game'
                //         }).catch(err => {
                //             console.error('默认跳转到首页失败:', err);
                //             router.replace('/').catch(e => console.error('备用默认跳转也失败:', e));
                //         });
                //     } else {
                //         if(router.currentRoute.value.path.indexOf('/sdk') === -1){
                //             router.replace({
                //                 name: 'mine',
                //             }).catch(err => console.error('默认跳转到我的页面失败:', err));
                //         }
                //     }
                // } catch (error) {
                //     console.error('默认路由跳转发生错误:', error);
                // }
            }
        } catch (error) {
            console.error('judgeJumpUrl函数执行失败:', error);
            // 发生错误时的最终回退方案：尝试跳转到首页
            try {
                if(router.currentRoute.value.path.indexOf('/sdk') === -1){
                    router.replace('/').catch(e => console.error('最终回退跳转也失败:', e));
                }
            } catch (finalError) {
                console.error('所有跳转尝试均失败:', finalError);
            }
        }
    }

    parseParam(url) {
        //地址链接分解出params
        const params = url.split('?')[1].split('&')
        let obj = {}
        params.forEach(item => {
            obj[item.split('=')[0]] = item.split('=')[1]
        });
        return obj /*{ user: 'anonymous', id: '456', city: '%E5%8C%97%E4%BA%AC' }*/
    }

    goLink(link, url = '') {
        if (delayLock) clearTimeout(delayLock);
        if (!link) return;
        delayLock = setTimeout(() => {
            if (this.isAPPClient()) {
                this.toLink(link);
            } else {
                if (url != '') {
                    const linkUrl = link + `${link.indexOf('?') > -1 ? '&' : '?'}token=${url}`
                    window.open(linkUrl)
                } else {
                    // window.location.href = link;
                    window.open(link)
                }
            }
        }, 200); //因为要兼容click / touch 的事件，不让重复点击
    }

    //跳转外部浏览器
    toLink(link, url = '') {
        if (link == '') {
            return false;
        }

        let linkUrl = link

        if (url != '') {
            linkUrl = link + `${link.indexOf('?') > -1 ? '&' : '?'}token=${url}`
        }

        try {
            try {
                if (this.isAPPClient()) {
                    this.jumpPhoneBrowser('0', linkUrl);
                } else {
                    this.alink(linkUrl)
                }
            } catch (error) {
                if (this.isAPPClient()) {
                    this.jumpPhoneBrowser('0', linkUrl);
                } else {
                    this.alink(linkUrl)
                }
            }
        } catch (error) {
            this.alink(linkUrl)
        }
    }

    goH5Game(url) {
        this.winOpen(url)
    };

    winOpen(url) {
        try {
            if (this.isAPPClient()) {
                // this.jumpPhoneBrowser('2', url, 1);
                this.jumpPhoneBrowser('0', url);
            } else {
                window.open(url)
                // const newPage = window.open(); // 打开一个不被拦截的空白窗口
                // newPage.location.href = ''
            }
        } catch (error) {
            window.location.href = url;
        }
    };

    winMiddleShow(url) {
        try {
            if (this.isAPPClient()) {
                this.jumpMiddleBrowser(url);
            } else {
                window.open(url)
            }
        } catch (error) {
            window.location.href = url;
        }
    };

    //创建a标签跳转（兼容性）
    alink(url) {
        var a = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('target', "__blank");
        document.body.appendChild(a);
        a.click();
    }

    // 跳转链接
    jumpLink(link, type = 'webview', carryParameters = {}, includeToken = true) {
        const isAPPClient = this.isAPPClient();
        let _link = link;

        // 准备用户信息参数
        const userParams = {};

        // 如果需要携带用户信息
        if (includeToken) {
            // 只获取carryParameters中没有提供的用户信息
            if (!('access_token' in carryParameters)) {
                const token = this.Cookie().get("access_token");
                if (token) userParams.access_token = token;
            }

            if (!('game_id' in carryParameters)) {
                const game_id = this.getStatInfo().game_id || this.getUrlParam("game_id") || '';
                if (game_id) userParams.game_id = game_id;
            }

            if (!('username' in carryParameters)) {
                const username = this.getStatInfo().username || store.state.userInfo.username || '';
                if (username) userParams.username = username;
            }
        }

        // 合并所有参数
        const allParams = { ...userParams, ...carryParameters };

        // 处理所有参数
        if (Object.keys(allParams).length > 0) {
            const paramStr = new URLSearchParams(allParams).toString();
            if (paramStr) {
                _link += _link.includes('?') ? `&${paramStr}` : `?${paramStr}`;
            }
        }
        console.log('_link', _link);
        // 跳转处理
        if(isAPPClient){
            if(type === 'webview'){
                this.alink(_link);
            }else{
                window.nativeBridge.browserJump({
                    type: "0",
                    url: _link,
                });
                this.jumpPhoneBrowser('0', _link);
            }
        } else {
            // 非APP环境直接跳转
            this.alink(_link);
        }
    }

    //更新用户个人信息，验证access_token的有效性
    async refreshUserInfo() {
        if (!this.Cookie().get("access_token")) {
            return false;
        }

        let apiUrl = '';
        switch(window.Config.platform){
            case 'mengw':
            case 'chuangyue':
                apiUrl = '/web/user/userInfo';
                break;
            case 'm9377':
                apiUrl = '/user/info';
                break;
            default:
                apiUrl = '/user/info';
                break;
        }


        let result = await Promise.all([this.getUserJson(apiUrl, "GET", {}, true), this.refreshUserVipInfo()]);
        const res = result[0];
        hasRedirected = false;

        if (res.code === 1) {
            userInfo = res.data
            store.commit("setUserInfo", res.data);
        }
        return res;
    }

    async getVideoInfo(params) {
        let str = '';
        for (const element of params) {
            str += `source_id[]=${element}&`
        }
        return this.getJson2(`/vod/getResource?${str}`, "GET", null, false);
    }
    //更新用户个人VIP信息，验证access_token的有效性, 是否刷新
    async refreshUserVipInfo() {
        const access_token = this.Cookie().get("access_token");
        // const access_token = JSON.parse(window.localStorage.getItem("access_token"));
        const res = await this.getJson2("/vip/v1/user_info", "GET", {
            access_token: access_token
        }, true);
        if (res.code === 0) {
            store.commit("setUserVipInfo", res.data);
        }

        return res;
    }

    async requestVipAssets() {
        const res = await this.getJson("/member/vip", "GET", {}, true);
        if (res.code === 1) {
            store.commit("setVipIcon", res.data.vip);
            store.commit("setVipRule", res.data.rule);
        }
        return res;
    }

    async requestDefaultIcons() {
        let icons = store.state.icons;
        if (JSON.stringify(icons) == "{}") {
            const res = await this.getJson("/common/icons", "GET", {}, true);
            if (res.code == 1) {
                store.commit("setIcons", res.data);
            }
            return res.data;
        } else {
            return icons;
        }
    }

    //加密用户信息 - 传入一个值,并传入一个加密的key; 其他解密方式都是不可逆的，目前先使用Base64的方法
    encrypt(msg) {
        return Base64.encode(msg);
    }
    //解密
    decrypt(msg) {
        return Base64.decode(msg);
    }
    //存储用户信息
    setUserListLocalStorage(name, data) {
        //获取本地存储，拿出要一个加密好的数组对象
        let arr = JSON.parse(localStorage.getItem(name));

        //如果本地存储不存在--第一次
        if (!arr) {
            //创建一个空数组
            let list = [];

            //加密
            data.user = this.encrypt(data.user);
            data.nickName = this.encrypt(data.nickName);
            data.pwd = this.encrypt(data.pwd);
            data.t = this.encrypt(data.t);
            data.en = 1;

            //添加至数组
            list.push(data);

            //转为字符串，存储
            localStorage.setItem(name, JSON.stringify(list));
            return true;
        } else {
            //存在本地存储的情况 -- 先解密
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].en == 1) {
                    arr[i].user = this.decrypt(arr[i].user);
                    arr[i].nickName = this.decrypt(arr[i].nickName);
                    arr[i].pwd = this.decrypt(arr[i].pwd);
                    arr[i].t = this.decrypt(arr[i].t);
                    arr[i].en = 0;
                }
            }

            // 使用filter过滤掉所有相同username的记录
            const filteredArr = arr.filter(item => item.user !== data.user);

            // 把新记录添加到数组开头
            filteredArr.unshift(data);

            // 重新加密所有记录
            for (let i = 0; i < filteredArr.length; i++) {
                if (filteredArr[i].en == 0) {
                    filteredArr[i].nickName = this.encrypt(filteredArr[i].nickName);
                    filteredArr[i].user = this.encrypt(filteredArr[i].user);
                    filteredArr[i].pwd = this.encrypt(filteredArr[i].pwd);
                    filteredArr[i].t = this.encrypt(filteredArr[i].t);
                    filteredArr[i].en = 1;
                }
            }

            localStorage.setItem(name, JSON.stringify(filteredArr));
            return true;
        }
    }
    //读取用户信息
    getUserListLocalStorage(name) {
        let arr = JSON.parse(localStorage.getItem(name));

        if (!arr) {
            return [];
        }
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].en == 1) {
                arr[i].nickName = this.decrypt(arr[i].nickName);
                arr[i].user = this.decrypt(arr[i].user);
                arr[i].pwd = this.decrypt(arr[i].pwd);
                arr[i].t = this.decrypt(arr[i].t);
                arr[i].en = 0;
            }
        }
        return arr;
    }
    //删除用户信息
    delUserListLocalStotage(name, user) {
        //获取本地存储，拿出要一个加密好的数组对象
        let arr = JSON.parse(localStorage.getItem(name));
        if (arr) {
            // 先解密所有用户信息
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].en == 1) {
                    arr[i].user = this.decrypt(arr[i].user);
                    arr[i].nickName = this.decrypt(arr[i].nickName);
                    arr[i].pwd = this.decrypt(arr[i].pwd);
                    arr[i].t = this.decrypt(arr[i].t);
                    arr[i].en = 0;
                }
            }

            // 过滤掉所有匹配的用户
            arr = arr.filter(item => item.user !== user);

            //加密
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].en == 0) {
                    arr[i].nickName = this.encrypt(arr[i].nickName);
                    arr[i].user = this.encrypt(arr[i].user);
                    arr[i].pwd = this.encrypt(arr[i].pwd);
                    arr[i].t = this.encrypt(arr[i].t);
                    arr[i].en = 1;
                }
            }

            localStorage.setItem(name, JSON.stringify(arr));
            return true;
        }
    }
    //检测 环境是否是PC环境， 是的话返回true， 不是的话返回false
    testEnv() {
        if (
            window.navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            )
        ) {
            // console.info('移动端')
            return false;
        } else {
            // console.info('PC')
            return true;
        }
    }

    async uploadPost(url, data) {
        // console.log('url====>', url);
        const token = this.Cookie().get("access_token");

        const headers = {
            // 'Origin': this.Vue.config.baseUrl, //新token传值方式
            // "Content-Type": _contentType,
        }

        if (token) {
            headers.Authorization = `Bearer ${token}`;
            headers['Company-Id'] = window.Config.companyId;
        }

        return await fetch(window.Config.host + '/api' + url, {
            method: "POST",
            headers,
            body: data, //this.encodeSearchParams(data)
        })
            .then((res) => {
                // console.log('url====>', url);
                if(toLoginApiArr.includes(url)){
                    if(res&&res.status === 401){
                        window.Components.toast('登录已过期，请重新登录');
                        let toPath = router.currentRoute.value.fullPath;
                        console.log('toPath====>', toPath);
                        this.Cookie().remove("access_token");
                        this.login({ query: { routerurl: toPath } })
                        return;
                    }
                }
                return res.text()
            })
            .then((res) => {
                if (res) {
                    const _returnData = JSON.parse(res);
                    if (_returnData.code == 0) {
                        return _returnData;
                    }

                    if (_returnData.code === 1 && !hasRedirected) {
                        hasRedirected = true;
                        window.Components.toast(_returnData.message);
                        _returnData.msg = _returnData.message;
                        // window.location.href = '/login';
                        this.Cookie().remove("access_token");
                        this.login()
                    }

                    if (res.code == 429) {
                        window.Components.toast("你的请求过于频繁，请稍后再操作");
                    }

                    return _returnData;
                } else {
                    window.Components.toast("系统错误");
                }
            })
            .catch((err) => {
                console.log('err====>', err);
                window.Components.toast("请求异常，请刷新后再试!");
            });
    }

    // S 文本复制 -- 手写无依赖
    copyText(text) {
        try {
            if (store.state.sdkInfo.isSdkEnv) {
                this.copyTextToClipboard(text);

                return true;
            } else {
                throw new Error();
            }
        } catch (err) {
            try {
                let input = document.createElement("input"); // js创建一个input输入框
                input.value = text; // 将需要复制的文本赋值到创建的input输入框中
                document.body.appendChild(input); // 将输入框暂时创建到实例里面
                input.select(); // 选中输入框中的内容
                document.execCommand("Copy"); // 执行复制操作
                document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作

                return true;
            } catch (err) {
                return false;
            }
        }
    }
    // E 文本复制 -- 手写无依赖

    // S 保存图片到本地 -- 手写无依赖
    saveFile(data) {
        try {
            const save_link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
            save_link.href = data;
            save_link.download = new Date().toLocaleString();

            const event = document.createEvent("MouseEvents");
            event.initMouseEvent(
                "click",
                true,
                false,
                window,
                0,
                0,
                0,
                0,
                0,
                false,
                false,
                false,
                false,
                0,
                null
            );
            save_link.dispatchEvent(event);
            return true;
        } catch (err) {
            return false;
        }
    }
    // E 保存图片到本地 -- 手写无依赖

    //处理时间 time格式 ： "2021-07-30 14:50:21"（String）
    timeHandle(time) {
        let timer = new Date();

        let year = timer.getFullYear();

        let month = timer.getMonth() + 1;

        let day = timer.getDate();

        let hours = timer.getHours();

        let minutes = timer.getMinutes();

        month = month < 10 ? "0" + month : month;
        day = day < 10 ? "0" + day : day;
        hours = hours < 10 ? "0" + hours : hours;

        if (year == time.substr(0, 4)) {
            //同一年

            if (month == time.substr(5, 2) && day == time.substr(8, 2)) {
                //同月同日

                if (hours == time.substr(11, 2)) {
                    //一个小时内
                    let historyTime = time.substr(14, 2);

                    if (minutes - historyTime <= 2) {
                        //两分钟内
                        return "刚刚";
                    } else {
                        return minutes - historyTime + "分钟前";
                    }
                } else {
                    return time.substr(11, 5);
                }
            } else {
                return time.substr(5, 5);
            }
        } else {
            return time.substr(0, 10);
        }
    }

    //处理时间 time格式 ： "2021-07-30 14:50:21"（String）,直接返回年月日
    timeManage(time) {
        return time.substr(0, 10)
    }

    // 根据性别 头像处理
    avatarConfig(gender) {
        if (gender == 1) {
            return "icon_avatar_boy";
        } else if (gender == 2) {
            return "icon_avatar_girl";
        } else if (gender == 0) {
            return "icon_avatar_neutral";
        } else {
            return "icon_avatar_nosign";
        }
    }

    login(params = {}, type, options = {}) {
        if (store.state.sdkInfo.isSdkEnv) {
            this.switchAccounts();
            return;
        }
        let query2 = router.currentRoute.value.query
        const query = params.query || {};
        const merged = Object.assign({}, query, query2);
        // if (type === 'replace') {
        //     router.replace({ name: 'login', query })
        //     return;
        // }
        // router.push({ name: 'login', query })

        this.goToLogin(merged, options);

    }

    //跳转客服
    async complaint() {
        this.clickStat('click_customer_service');
        if (store.state.sdkInfo.isSdkEnv) {
            this.jumpToServiceOnline();
            return;
        }
        // const res = await this.getJson2("/kefu/getInfo:", "GET", {}, false);
        const res = {
            code: 1
        };

        if (res.code == 1) {
            // const url = 'https://wvw.9377.cn/qy_kefu.php?source=9';
            const url = window.Config.kefuUrl;
            const currentRoutePath = router.currentRoute.value.path;
            router.push({name: 'iframe-view', query: {url: url, name: router.currentRoute.value.name, back_route: currentRoutePath}});
            // if (window.Config.isAndroid) {
            //     router.push({
            //         path: "/IframeOrder",
            //         query: {
            //             title: encodeURIComponent("在线客服"),
            //             url: url,
            //         },
            //     });
            // } else if (window.self === window.top) {
            //     window.location.href = url;
            // } else {
            //     window.open(url);
            // }
            // this.winOpen(url)
        } else {
            window.Components.toast(res.msg);
        }
    }

    //跳转反馈
    async feedback() {
        const url = window.Config.feedbackUrl;
        this.winOpen(url)
    }

    //上报行为获取sign
    statsSign(keyCode) {
        return md5(keyCode);
    }

    // S 登录行为上报请求
    statsLogin(way = 0) {
        let report = sessionStorage.getItem("report");
        if (report) {
            report = JSON.parse(report);
            let timer = new Date().getTime() - report.times;

            report["way"] = way;
            sessionStorage.setItem("report", JSON.stringify(report));

            if (timer <= window.Config.timeDiff) {
                this.reportLoginAction(window.Config.timeDiff - timer); //如果是一定时间内上报过了，就再等这么久的时间再上报
            } else {
                this.reportLoginAction(1000); //表示立即上报
            }
        } else {
            let params = window.location.search;
            let obj = {
                times: new Date().getTime(),
                way: way,
                type: 1,
            };
            if (params) {
                params = params.substr(1, params.length).split("&");
                for (let i in params) {
                    obj[params[i].split("=")[0]] = params[i].split("=")[1];
                }
            }
            sessionStorage.setItem("report", JSON.stringify(obj));
            this.reportLoginAction(1000); //表示立即上报
        }
    }

    reportLoginAction(timeout) {
        //存在token表示在登录，就执行上报心跳操作
        if (this.Cookie().get("access_token")) {
            setTimeout(async () => {
                let report = JSON.parse(sessionStorage.getItem("report"));
                let nowTime = new Date().getTime(); //获取时间戳，接口里、签名里要统一
                let params = {
                    type: report.type,
                    account: store.state.userInfo.username,
                    game_id: report.gameid || "",
                    device_id: report.device_id || "",
                    channel: report.channel || "",
                    way: report.way || 0,
                    timestamp: nowTime,
                    sign: this.statsSign(
                        store.state.userInfo.username + nowTime + window.Config.keyCode
                    ),
                };
                // const res = await this.getJson("/stats/login", "POST", params, true);
                // if (res.code == 1) {
                //     report.times = new Date().getTime();
                //     sessionStorage.setItem("report", JSON.stringify(report));
                //     this.reportLoginAction(window.Config.timeDiff);
                // }
            }, timeout);
        }
    }
    // S 登录行为上报请求

    // S 普通用户行为上报请求, 要加500毫秒延迟，避免获取不到用户名
    reportPageAction(page) {
        setTimeout(() => {
            //存在token表示在登录，就执行上报心跳操作
            // if (this.Cookie().get("access_token")) {
            let report = JSON.parse(sessionStorage.getItem("report"));
            let nowTime = new Date().getTime(); //获取时间戳，接口里、签名里要统一
            let params = {
                type: report.type,
                account: store.state.userInfo.username,
                game_id: report.gameid || "",
                device_id: report.device_id || "",
                channel: report.channel || "",
                page: page,
                timestamp: nowTime,
                sign: this.statsSign(page + nowTime + window.Config.keyCode),
            };
            // const res = this.getJson("/stats/visit", "POST", params, true);
            // }
        }, 500);
    }
    // E 普通用户行为上报请求, 要加500毫秒延迟，避免获取不到用户名

    // S 设备激活 -- 一台设备只会激活一次
    async equipmentActivation() {
        let isActive = localStorage.getItem("isactive");
        if (!isActive) {
            try {
                let report = JSON.parse(sessionStorage.getItem("report"));
                let nowTime = new Date().getTime(); //获取时间戳，接口里、签名里要统一
                let params = {
                    type: report.type,
                    game_id: report.gameid || "",
                    device_id: report.device_id || "",
                    channel: report.channel || "",
                    timestamp: nowTime,
                    sign: this.statsSign(report.device_id + nowTime + window.Config.keyCode),
                };
                // const res = await this.getJson("/stats/active", "POST", params, true);
                // if (res.code == 1) {
                //     localStorage.setItem("isactive", true);
                // } else {
                //     console.info(res.msg);
                // }
            } catch (err) {
                console.info(err);
            }
        }
    };
    // E 设备激活 -- 一台设备只会激活一次

    // S 离开当前页面，去往需要登录的页面的拦截
    leaveIntercept(to) {
        let arr = ["editForum", "commentedit", "userinfo", "message", "minerecord", "treasurechest"];
        if (arr.indexOf(to.name) > -1) {
            if (new Util().Cookie().get("access_token")) {
                return true;
            } else {
                // try {
                //     window.Config.rebackUrl = to.name;
                //     AndroidUtils.localMobleLogin();
                // } catch (error) {
                //     this.login({ query: { routerurl: to.path } })
                // }
                this.login({ query: { routerurl: to.path } })
            }
        } else {
            return true;
        }
    };
    // E 离开当前页面，去往需要登录的页面的拦截

    async signOut() {
        let apiUrl = '';
        switch(window.Config.platform){
            case 'mengw':
            case 'chuangyue':
                apiUrl = '/web/user/logout';
                break;
            case 'm9377':
                apiUrl = '/user/logout';
                break;
            default:
                apiUrl = '/user/logout';
                break;
        }
        const res = await this.getJson(apiUrl, "POST", {}, true);
        if (res.code == 1) {
            userInfo = {}
            store.commit("setUserInfo", {});
            userInfo = {}
            this.Cookie().remove('access_token');
            this.login({}, 'replace')
            window.Components.toast('退出成功');
        };
    };

    removeHtml(str) {
        var regex = /(<([^>]+)>)/ig;
        return str.replace(regex, "");
    };

    //存储用户信息配置
    setUserConfiguration(obj) {
        if (JSON.stringify(userInfo) === "{}") {
            return
        }
        //获取本地存储，拿出要一个加密好的数组对象
        let arr = JSON.parse(localStorage.getItem('userConfiguration'));
        let data = [];
        if (obj) {
            data = { ...userInfo, ...obj }
        }
        //如果本地存储不存在--第一次
        if (!arr) {
            //创建一个空数组
            let list = [];
            //添加至数组

            list.push(data);

            //转为字符串，存储
            localStorage.setItem('userConfiguration', JSON.stringify(list));
            return true;
        } else {
            //存在本地存储的情况 -- 先解密 -- 判断下账号是否一样，有一样的账号，就先删除旧的，把新的插进去
            for (let i in arr) {
                if (arr[i].username == data.username) {
                    arr.splice(i, 1);
                    break;
                }
            }

            arr.unshift(data);
            localStorage.setItem('userConfiguration', JSON.stringify(arr));
            return true;
        }
    }
    //读取用户信息配置
    async getUserConfiguration(name) {
        if (JSON.stringify(userInfo) === "{}") {
            let res = await this.refreshUserInfo();
            if (res.code == 1) {
                userInfo = res.data
            }
        }
        let arr = JSON.parse(localStorage.getItem('userConfiguration'));
        if (!arr && !userInfo) {
            return false;
        }
        for (let i in arr) {
            if (arr[i].username == userInfo.username) {
                return arr[i][name];
            }
        }
        return false;
    }

    /**
    * 将秒转换成分秒返回
    * @param {Number} seconds  传入的秒数
    */
    formatTime = (seconds) => {
        if (seconds === 0) {
            return '0秒';
        }

        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;

        if (hours > 0) {
            return `${hours}时${minutes}分`;
        } else if (minutes > 0) {
            return `${minutes}分${remainingSeconds}秒`;
        } else {
            return `${remainingSeconds}秒`;
        }
    }

    /**
    * 解码
    * @param {String} str  字符串
    */
    encodeContent = (str) => {
        if (!str) return '';
        var arrEntities = { 'lt': '<', 'gt': '>', 'quot': '"', 'nbsp': '<br/>' };
        return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) { return arrEntities[t]; }).replace(/nbsp;/g, ' ');
    }

    /**
    * 清空对象里面的空值
    * @param {Object} obj 对象
    */
    removeEmptyValues = (obj) => {
        for (const key in obj) {
            if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
                delete obj[key];
            }
        }
        return obj;
    }

    // 判断 是不是微信浏览器是不是apk包如果是就引导下载如果不是就直接用a标签跳转
    checkUrlAndWx = (url) => {
        let status = false
        //判断当前是不是微信浏览器
        let isWX = navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
        //判断url是不是apk包
        let isApk = url.endsWith(".apk");
        if (Boolean(isWX) && Boolean(isApk)) {
            status = true
        } else {
            //通过a标签的方式下载
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.setAttribute('_blank', '');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            status = false
        }
        return status
    }
    setLocalStatInfo = () => {
        let localStatInfo = sessionStorage.getItem("localStatInfo");
        const platform = this.getUrlParam("platform");
        const business_type = this.getUrlParam("business_type");
        const division = this.getUrlParam("division");
        const app_version = this.getUrlParam("app_version");
        const game_id = this.getUrlParam("game_id");
        if (!localStatInfo) {
            const obj = {};
            obj.platform = platform || '0';
            obj.business_type = business_type || 'tool_phone_box';
            obj.division = companyEnum[window.Config.platform] || division || '';
            obj.app_version = app_version || window.Config.version;
            obj.game_id = game_id || window.Config.default_game_id;
            sessionStorage.setItem('localStatInfo', JSON.stringify(obj));
            return;
        }
        let params = window.location.search;
        if (params) {
            const localStatInfoObj = JSON.parse(localStatInfo);
            params = params.substr(1, params.length).split("&");
            for (let i in params) {
                localStatInfoObj[params[i].split("=")[0]] = params[i].split("=")[1];
            }
            sessionStorage.setItem('localStatInfo', JSON.stringify(localStatInfoObj));
        }
    }
    getStatInfo = () => {
        const localStatInfo = JSON.parse(sessionStorage.getItem("localStatInfo")) || {};
        return localStatInfo;
    }
    sendStat = (eid, reportParams = {}) => {
        const IsProd = window.Config.env == 'production';
        const statOptions = {
            IsProd,
            IsLog: !IsProd,
            CryptoJS_: CryptoJS,
        };
        if (!window.boxStat) {
            window.boxStat = new Stat(statOptions);
        }
        const { business_type, platform, division, app_version } = this.getStatInfo();
        const common = {
            business_type,
            division: companyEnum[window.Config.platform] || division || '',
        };
        common.eid = eid
        let sysInfo = JSON.parse(sessionStorage.getItem("sysInfo")) || {};
        let report = {
            mac: sysInfo.mac || '',
            androidid: sysInfo.androidid || '',
            device_id: sysInfo.device_id || '',
            device_oaid: sysInfo.device_oaid || '',
            device_imei: sysInfo.device_imei || '',
            device_os: sysInfo.device_os || '',
            account: store.state.userInfo.username || '',
            uid: store.state.userInfo.user_id || '',
            platform,
            app_version,
            ...reportParams
        };

        // 将所有字段转为字符串格式，数组用逗号分割，对象用JSON.stringify
        const processedReport = {};
        for (const [key, value] of Object.entries(report)) {
            if (value === null || value === undefined) {
                processedReport[key] = '';
            } else if (Array.isArray(value)) {
                processedReport[key] = value.join(',');
            } else if (typeof value === 'object') {
                processedReport[key] = JSON.stringify(value);
            } else {
                processedReport[key] = String(value);
            }
        }

        // 更新处理后的报告数据
        report = processedReport;


        window.boxStat.sendStat({
            common,
            report,
        });
    }
    enterStat = (eid, report = {}) => {
        report.url = location.href
        this.sendStat(eid, report)
    }
    clickStat = (eid, report) => {
        this.sendStat(eid, report)
    }

    getRechargeUrl = () => {
        if(window.Config.platform == 'm9377') {
            return window.Config.env === 'production' ? 'https://pay.9377.cn' : 'https://pay-test.9377.cn'
        } else {
            return window.Config.env === 'production' ? 'https://pay.mengw.com' : 'https://pay-test.mengw.com'
        }
    }

    //更新sdk自动登录开关
    refreshSdkAutoLoginStatus(status) {
        let sdkInfo = store.state.sdkInfo;
        sdkInfo.autoLoginStatus = Boolean(status);
        store.commit("setSdkInfo", sdkInfo);
    }

    //更新sdk悬浮球状态
    refreshSdkFloatingBallStatus(status) {
        let sdkInfo = store.state.sdkInfo;
        sdkInfo.floatingBallStatus = Boolean(status);
        store.commit("setSdkInfo", sdkInfo);
    }

    //设置sdk礼包红点数
    setSdkGiftNumber(number) {
        let sdkInfo = store.state.sdkInfo;
        sdkInfo.giftNumber = number;
        store.commit("setSdkInfo", sdkInfo);
    }

    customToast(text) {
        if (store.state.sdkInfo.isSdkEnv) {
            this.clientToast(text);
            return;
        }
        window.Components.toast(text)
    }

    setAndroidAppEnv() {
        let sdkInfo = store.state.sdkInfo;
        sdkInfo.isAppEnv = true;
        store.commit("setSdkInfo", sdkInfo);
    }

    setAndroidSdkEnv() {
        let sdkInfo = store.state.sdkInfo;
        sdkInfo.isSdkEnv = true;
        store.commit("setSdkInfo", sdkInfo);
    }

    setOrientation() {
        let sdkInfo = store.state.sdkInfo;
        sdkInfo.isLandscape = true;
        store.commit("setSdkInfo", sdkInfo);
    }

    hiddenWin() {
        if (store.state.sdkInfo.isSdkEnv) {
            this.hideFloatview()
            return;
        }
    }

    getSysInfo() {
        try {
            const event = 3;
            const sendParams = {
                event,
            };
            return this.sendMessageByJs(sendParams, true);
        } catch (err) {
            console.log("获取系统信息错误:", err);
            return Promise.resolve({});
        }
    }

    getAppOrientation() {
        return new Promise(async (resolve) => {
            try {
                const event = 1;
                const sendParams = {
                    event,
                };
                const res = await this.sendMessageByJs(sendParams, true);
                const { ori = 1 } = res;
                ori === 0 && this.setOrientation();
                resolve(ori);
            } catch (err) {
                console.log("获取App方向错误:", err);
                resolve(1);
            }
        });
    }

    getAppClient() {
        // 包括androidsdk,iossdk
        // 如需区分androidsdk/iossdk需结合使用isIOSClient
        return new Promise(async (resolve) => {
            try {
                const event = 39;
                const sendParams = {
                    event,
                };
                const res = await this.sendMessageByJs(sendParams, true);
                console.log("getAppClient res:", res)
                const { rq_environment = '' } = res;
                rq_environment === "cs_sdk" && (window.Config.isSdk = true) && this.setAndroidSdkEnv();
                resolve(rq_environment);
            } catch (err) {
                console.log("获取App客户端信息错误:", err);
                resolve('');
            }
        });
    }

    getSdkFloatingBallStatus() {
        const event = 19;
        const sendParams = {
            event,
        };
        return this.sendMessageByJs(sendParams, true);
    }

    getSdkAutoLoginStatus() {
        const event = 20;
        const sendParams = {
            event,
        };
        return this.sendMessageByJs(sendParams, true);
    }

    setSdkFloatingBallStatus(sw_fb) {
        const event = 16;
        const sendParams = {
            event,
            data: { sw_fb },
        };
        return this.sendMessageByJs(sendParams, true);
    }

    setSdkAutoLoginStatus(auto_sw) {
        const event = 18;
        const sendParams = {
            event,
            data: { auto_sw },
        };
        return this.sendMessageByJs(sendParams, true);
    }

    hideFloatview() {
        const event = 25;
        const sendParams = {
            event,
            data: { "sw_fv": 0 }
        };
        this.sendMessageByJs(sendParams);
    }

    switchAccounts() {
        const event = 23;
        const sendParams = {
            event,
        };
        this.sendMessageByJs(sendParams);
    }

    copyTextToClipboard(msg) {
        const event = 14;
        const sendParams = {
            event,
            data: { msg },
        };
        this.sendMessageByJs(sendParams);
    }

    jumpToServiceOnline() {
        const event = 24;
        const sendParams = {
            event,
        };
        this.sendMessageByJs(sendParams);
    }

    jumpPhoneBrowser(type, url, hideBar = 0) {
        const event = 6;
        const sendParams = {
            event,
            data: { type, url, hideBar },
        };
        if(typeof AndroidUtils !== 'undefined' && AndroidUtils) {
            AndroidUtils.jumpBrowser(url)
        }else {
            this.sendMessageByJs(sendParams);
        }
    }

    jumpMiddleBrowser(url) {
        const event = 42;
        const sendParams = {
            event,
            data: { url, title: '', type: 1 },
        };
        this.sendMessageByJs(sendParams);
    }

    // 打开横屏模式右边的webview
    jumpLandscapeBrowser(params) {
        const { url, title = '', scale = 0, hideToolbar = 0 } = params
        const event = 40;
        const sendParams = {
            event,
            data: { url, title, scale, hideToolbar },
        };
        this.sendMessageByJs(sendParams);
    }

    clientToast(msg) {
        const event = 43;
        const sendParams = {
            event,
            data: { msg },
        };
        this.sendMessageByJs(sendParams);
    }

    closeApp() {
        const event = 21;
        const sendParams = {
            event,
        };
        this.sendMessageByJs(sendParams);
    }

    jumpQQ(qqGroupKey) {
        const event = 31;
        const sendParams = {
            event,
            data: { qqGroupKey },
        };
        this.sendMessageByJs(sendParams);
    }

    clientShare(params) {
        const event = 15;
        /**
            * params
            * @type {string} channel - QQ、WX、WEIBO、WEIBO_MOMENTS
            * @type {string} shareMsg - 内容
            */
        const sendParams = {
            event,
            data: params,
        };
        this.sendMessageByJs(sendParams);
    }

    // 检测是否为微信小程序环境
    async isWechatMiniapp() {
        try {
            // 首先，快速检测是否可能是微信环境
            // 如果 userAgent 中没有 MicroMessenger 关键词，则肯定不是微信环境
            if (!/MicroMessenger/i.test(navigator.userAgent)) {
                console.log('非微信环境，跳过微信小程序检测');
                return false;
            }

            // 方法一：通过 userAgent 判断
            const isMiniProgramByUA = /miniProgram/i.test(navigator.userAgent.toLowerCase());

            // 如果 userAgent 已经明确是小程序，可以提前返回结果
            if (isMiniProgramByUA) {
                console.log('通过 userAgent 直接判断为微信小程序环境');
                return true;
            }

            // 方法二和方法三：确保在 WeixinJSBridge 准备好后再获取环境
            let isMiniProgramByEnv = false;
            let isMiniProgramByAPI = false;
            let isMiniProgramByUserAgent = false;

            // 创建一个Promise，在WeixinJSBridgeReady事件触发时解析
            // 设置较短的超时时间，防止长时间等待影响页面加载
            const wxJSBridgeReadyPromise = new Promise((resolve) => {
                const wxReady = () => {
                    try {
                        // 通过 window.__wxjs_environment 判断
                        if (typeof window.__wxjs_environment !== 'undefined') {
                            isMiniProgramByEnv = window.__wxjs_environment === 'miniprogram';
                            if (isMiniProgramByEnv) {
                                resolve(true);
                                return;
                            }
                        }

                        // 通过 wx.miniProgram.getEnv 判断
                        if (typeof wx !== 'undefined' && wx.miniProgram && typeof wx.miniProgram.getEnv === 'function') {
                            try {
                                wx.miniProgram.getEnv(function(res) {
                                    isMiniProgramByAPI = !!res.miniprogram;
                                    resolve(isMiniProgramByAPI);
                                });
                            } catch (error) {
                                console.error('wx.miniProgram.getEnv 调用失败:', error);
                                resolve(false);
                            }
                        } else {
                            // 通过 wx.getRendererUserAgent 判断（微信新版本API）
                            if (typeof wx !== 'undefined' && typeof wx.getRendererUserAgent === 'function') {
                                try {
                                    // 尝试使用Promise风格调用
                                    if (wx.getRendererUserAgent) {
                                        wx.getRendererUserAgent().then(userAgent => {
                                            console.log('UserAgent (Promise):', userAgent);
                                            // 判断返回的 userAgent 是否包含 miniprogram 字符串
                                            if (userAgent && typeof userAgent === 'string' && /miniProgram/i.test(userAgent.toLowerCase())) {
                                                console.log('通过 getRendererUserAgent Promise 返回的 UA 判断为微信小程序环境');
                                                isMiniProgramByUserAgent = true;
                                                resolve(true);
                                            } else {
                                                console.log('getRendererUserAgent Promise 返回的 UA 不包含小程序标识');
                                                resolve(false);
                                            }
                                        }).catch(err => {
                                            console.error('获取 UserAgent Promise方式调用失败:', err);
                                            resolve(false);
                                        });
                                    } else {
                                        // 使用回调函数风格调用
                                        wx.getRendererUserAgent({
                                            success(res) {
                                                console.log('UserAgent (Callback):', res.userAgent);
                                                // 判断返回的 userAgent 是否包含 miniprogram 字符串
                                                if (res.userAgent && /miniProgram/i.test(res.userAgent.toLowerCase())) {
                                                    console.log('通过 getRendererUserAgent 返回的 UA 判断为微信小程序环境');
                                                    isMiniProgramByUserAgent = true;
                                                    resolve(true);
                                                } else {
                                                    console.log('getRendererUserAgent 返回的 UA 不包含小程序标识');
                                                    resolve(false);
                                                }
                                            },
                                            fail(err) {
                                                console.error('获取 UserAgent 回调方式调用失败:', err);
                                                resolve(false);
                                            }
                                        });
                                    }
                                } catch (error) {
                                    console.error('获取 UserAgent Promise方式调用失败:', error);
                                    resolve(false);
                                }
                            } else {
                                resolve(false);
                            }
                        }
                    } catch (error) {
                        console.error('wxReady 函数执行出错:', error);
                        resolve(false);
                    }
                };

                // 检查WeixinJSBridge是否已加载
                if (typeof window.WeixinJSBridge !== 'undefined' && window.WeixinJSBridge.invoke) {
                    wxReady();
                } else if (typeof document !== 'undefined') {
                    try {
                        document.addEventListener('WeixinJSBridgeReady', wxReady, false);
                        // 设置超时，防止长时间等待，使用更短的超时时间
                        setTimeout(() => resolve(false), 1000);
                    } catch (error) {
                        console.error('注册 WeixinJSBridgeReady 事件失败:', error);
                        resolve(false);
                    }
                } else {
                    resolve(false);
                }
            });

            // 等待WeixinJSBridge加载完成或超时
            try {
                const result = await Promise.race([
                    wxJSBridgeReadyPromise,
                    // 增加一个额外的超时保护
                    new Promise(resolve => setTimeout(() => resolve(false), 1500))
                ]);

                if (result === true) {
                    return true;
                }
            } catch (error) {
                console.error('等待WeixinJSBridge加载失败:', error);
            }

            // 综合判断结果
            const isWechatMiniapp = isMiniProgramByUA || isMiniProgramByEnv || isMiniProgramByAPI || isMiniProgramByUserAgent;

            console.log('微信小程序环境检测结果:', {
                isMiniProgramByUA,
                isMiniProgramByEnv,
                isMiniProgramByAPI,
                isMiniProgramByUserAgent,
                final: isWechatMiniapp
            });

            return isWechatMiniapp;
        } catch (error) {
            console.error('检测微信小程序环境出错:', error);
            return false;
        }
    }

    postToParent(params) {
        const event = 45;
        /**
             * params
             * @type {string} channel - QQ、WX、WEIBO、WEIBO_MOMENTS
             * @type {string} shareMsg - 内容
             */
        const sendParams = {
            event,
            data: params,
        };
        this.sendMessageByJs(sendParams);
    }

    updateUserLoginInfo(params) {
        const access_token = this.Cookie().get("access_token");
        const { login_type = 'password', username, password } = params
        const event = 28;
        const sendParams = {
            event,
            data: { login_type, username, password, jwt_token: access_token, access_token },
        };
        this.sendMessageByJs(sendParams);
    }

    sendUserLoginInfo(access_token, username) {
        // const access_token = this.Cookie().get("access_token");
        console.log('调用了方法传access_token和username给安卓', access_token, username)
        const event = 28;
        const sendParams = {
            event,
            data: { access_token, username },
        };
        this.sendMessageByJs(sendParams);
    }

    genCbId() {
        return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
    }

    sendMessageByJs(params, callback) {
        return new Promise((resolve) => {
            const callbackId = this.genCbId()
            if (callback) {
                window.sdkBridge[callbackId] = resolve
                params.callbackId = callbackId;
            }
            const jsonParams = JSON.stringify(params)
            if (window.CSFloatWebviewJSImpl && window.CSFloatWebviewJSImpl.passEvent) {
                window.CSFloatWebviewJSImpl.passEvent(jsonParams)
            } else if (
                window.webkit &&
                window.webkit.messageHandlers &&
                window.webkit.messageHandlers.passEvent &&
                window.webkit.messageHandlers.passEvent.postMessage
            ) {
                window.webkit.messageHandlers.passEvent.postMessage(jsonParams);
            } else {
                console.log('未找到客户端方法')
                if (callback) {
                    params.data = {}
                    try {
                        window.natiCallJS(params)
                    } catch (err) {
                        console.log('未找到客户端方法', err)
                    }
                }
            }
        });
    }

    isAPPClient() {
        // 包括iosapp,androidapp,iossdk,androidsdk
        // 如需区分app/sdk需结合使用getAppClient
        return !!((window.CSFloatWebviewJSImpl && window.CSFloatWebviewJSImpl.passEvent)) || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.passEvent && window.webkit.messageHandlers.passEvent.postMessage) || (typeof AndroidUtils !== 'undefined' && AndroidUtils)
    }

    isIOSClient() {
        // 包括iosapp,iossdk
        // 如需区分app/sdk需结合使用getAppClient
        return !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.passEvent && window.webkit.messageHandlers.passEvent.postMessage)
    }

    isAndroidClient() {
        // 包括androidapp,androidsdk
        // 如需区分app/sdk需结合getAppClient使用
        return !!((window.CSFloatWebviewJSImpl && window.CSFloatWebviewJSImpl.passEvent)) || (typeof AndroidUtils !== 'undefined' && AndroidUtils)
    }

    goToRealname(query = {}) {
        // const baseParams = this.statUtil.getBaseReport();

        const { business_type, platform, division, app_version } = this.getStatInfo();
        const params = {
            redirecturl: top.location.origin + top.location.pathname + (this.encodeSearchParams(query) ? ('?' + this.encodeSearchParams(query)) : ''),
            business_type: business_type || window.Config.business_type || '',
            platform: platform || '',
            app_version: app_version || '',
            gameid: this.getUrlParam("game_id") || '51211' || '',
            division: companyEnum[window.Config.platform] || division || '',
            access_token: this.getCookieLocalStorage('access_token')||'',
        };

        // 过滤空值
        const filteredParams = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== undefined && value !== '')
        );

        const queryParams = new URLSearchParams(filteredParams).toString();
        // 跳转实名微服务
        top.location.href = `${top.Config.authHost}${top.Config.authRealnamePath}?${queryParams}`;
    }

    showTime(dateString) {
        //时间的显示规则
        let dateDate = dateString.split(' ')[0];
        //日期
        let dateTime = dateString.split(' ')[1];
        //时间
        let dateYear = dateDate.split('-')[0];
        //获取传入时间的年份
        let newDateTime = dateTime.split(':')[0] + ':' + dateTime.split(':')[1];
        //展示时和分
        let date = new Date(dateString)
        let today = new Date()
        today.setHours(0)
        today.setMinutes(0)
        today.setSeconds(0)
        // today 为今天凌晨的时间
        let todayYear = today.getFullYear();
        //获取今天的年份
        let dayTime = 24 * 60 * 60 * 1000
        let delta = today - date // 得到相差的时间 ms
        if(todayYear == dateYear) {
            //先判断是否为今年
            if (delta > 0) {
                //比今天更早
                if (delta <= dayTime) {
                    //昨天
                    return ('昨天 ' + newDateTime);
                }else {
                    //比昨天更早
                    let newDate = dateDate.split('-')[1] + '月' + dateDate.split('-')[2] + '日';
                    return newDate;
                }
            } else if (-delta < dayTime) {
                //今天
                return newDateTime;
            }else {
                let newDate = dateDate.split('-')[1] + '月' + dateDate.split('-')[2] + '日';
                return newDate;
            }
        }else {
            //非今年
            let newDate = dateDate.split('-')[0] + '年' + dateDate.split('-')[1] + '月' + dateDate.split('-')[2] + '日';
            return newDate;
        }
    }

    async goToLogin(query = {}, options = {}) {
        // const baseParams = this.statUtil.getBaseReport();
        const { game_id, business_type, platform, division, app_version } = this.getStatInfo();
        const params = {
            redirecturl: top.location.origin/* + top.location.pathname*/ + (this.encodeSearchParams(query) ? ('?' + this.encodeSearchParams(query)) : ''),
            business_type: business_type || window.Config.business_type || '',
            platform: platform || '',
            app_version: app_version || '',
            gameid: game_id || this.getUrlParam("game_id") || window.Config.default_game_id || '',
            game_id: game_id || this.getUrlParam("game_id") || window.Config.default_game_id || '',
            division: companyEnum[window.Config.platform] || division || '',
        };
        if (options.account) {
            params.account = options.account; // 手机号或者用户名
        }
        if (options.login_type) {
            params.login_type = options.login_type; // mobile手机号码 username用户名
        }
        // 过滤空值
        const filteredParams = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== undefined && value !== '')
        );

        const queryParams = new URLSearchParams(filteredParams).toString();

        const isWechatMiniapp = await this.isWechatMiniapp();

        const isPC = () => {
            const userAgent = navigator.userAgent.toLowerCase();
            // 常见移动设备关键字列表
            const mobileKeywords = [
                'android', 'iphone', 'ipod', 'ipad', 'windows phone',
                'blackberry', 'webos', 'mobi', 'opera mini', 'mobile'
            ];
            // 如果用户代理字符串中包含任何移动设备关键字，则认为是非PC（即移动端）
            return !mobileKeywords.some(keyword => userAgent.includes(keyword));
        }

        if(window.Config.platform == 'chuangyue') {
            if(isWechatMiniapp) {
                // const container = document.getElementById('game_login_box');
                // container.style.display = 'block';
                if(isPC()) {
                    top.location.href = `${top.Config.authHost}${top.Config.authLoginPath}?${queryParams}`;
                }else {
                    const { game_id } = this.getStatInfo();
                    wx.miniProgram.navigateTo({
                        url: `/subpackages/chuangyue/pages/login/login?isBox=1&game_id=${game_id}`,
                    })
                }
            }else {
                top.location.href = `${top.Config.authHost}${top.Config.authLoginPath}?${queryParams}`;
            }
        }else {
            // 跳转登录微服务
            top.location.href = `${top.Config.authHost}${top.Config.authLoginPath}?${queryParams}`;
        }
    }
}

export default Util;
